import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { toast } from "react-hot-toast";
import OrganisationLayout from "../layout/OrganisationLayout";
import { organisationUpdatePasswordAction } from "../../Redux/Action/OrganisationAction";
import * as Yup from "yup";

export default function OrganisationGroupsUpdatePassword() {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
    },
    validationSchema: Yup.object().shape({
      oldPassword: Yup.string().required("Old password is required"),
      newPassword: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("New password is required"),
    }),
    onSubmit: async (values) => {
      const response = await dispatch(organisationUpdatePasswordAction(values));

      if (response?.payload?.statusCode === 200) {
        formik.resetForm();
        toast.success(response?.payload?.message || "Password Updated Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(response?.payload?.message || "Unable to update password.");
      }
    },
  });

  const cardStyle = {
    background: "#EEF5FF",
    minHeight: "100vh",
    padding: "40px 20px",
  };

  const updateCardStyle = {
    background: "#fff",
    borderRadius: "24px",
    padding: "40px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    position: "relative",
  };

  const inputStyle = {
    background: "#C0D1FF",
    border: "2px solid transparent",
    backgroundImage: "linear-gradient(#C0D1FF, #C0D1FF), linear-gradient(to right, #4318FF, #D200A5)",
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    borderRadius: "12px",
    padding: "12px 16px",
    color: "#2B3674",
    fontWeight: "500",
    height: "50px",
  };

  const labelStyle = {
    color: "#2B3674",
    fontWeight: "600",
    fontSize: "14px",
    marginBottom: "8px",
    display: "block",
  };

  const buttonStyle = {
    background: "linear-gradient(90deg, #D200A5 0%, #D200A5 100%)",
    border: "none",
    borderRadius: "30px",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    padding: "14px 40px",
    marginTop: "20px",
    width: "fit-content",
    transition: "transform 0.2s ease",
  };

  return (
    <OrganisationLayout>
      <div style={cardStyle}>
        <Container fluid>
          <Row className="justify-content-center">
            <Col xxl={5} xl={6} lg={8} md={10}>
              <div style={updateCardStyle}>
                <div className="back-page-title mb-4">
                  <Link to="/organisations/settings">
                    <div style={{
                      background: "#fff",
                      borderRadius: "10px",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                    }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M13.75 5.5L8.25 11L13.75 16.5"
                          stroke="#CCD2E3"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </Link>
                </div>
                
                <div className="text-center mb-5">
                  <h2 style={{ color: "#2B3674", fontWeight: "800", fontSize: "28px" }}>Update Password</h2>
                </div>

                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label style={labelStyle}>Old Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Type Here"
                      name="oldPassword"
                      style={inputStyle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.oldPassword}
                      className="organisation-password-input"
                    />
                    {formik.touched.oldPassword && formik.errors.oldPassword && (
                      <div className="error text-danger mt-1 small" style={{ fontWeight: "600" }}>{formik.errors.oldPassword}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label style={labelStyle}>New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Type Here"
                      name="newPassword"
                      style={inputStyle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.newPassword}
                      className="organisation-password-input"
                    />
                    {formik.touched.newPassword && formik.errors.newPassword && (
                      <div className="error text-danger mt-1 small" style={{ fontWeight: "600" }}>{formik.errors.newPassword}</div>
                    )}
                  </Form.Group>

                  <div className="d-flex justify-content-center">
                    <button 
                      type="submit" 
                      style={buttonStyle}
                      onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.02)"}
                      onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                    >
                      Update Password
                    </button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </OrganisationLayout>
  );
}
